import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getQuotationHandlerSaga(action) {
  const apiClient = apiClientFactory();
  try {
   const url = endPoint.dynamicList({ path: "quotation",...action.payload });

const { data } = yield call(apiClient.get, `${url}`);
    yield put({
      type: types.GET_QUOTATION_SUCCESS,
      payload: data.response,
    });
  } catch (e) {
    const payload = e?.response?.data || e;
    yield put({
      type: types.GET_QUOTATION_ERROR,
      payload,
    });
  }
}

export function* getQuotationWatcherSaga() {
  yield takeLatest(types.GET_QUOTATION_START, getQuotationHandlerSaga);
}

//delete

function* deleteQuotationHandlerSaga(action) {
  const apiClient = apiClientFactory();
  try {
    const { data } = yield call(
      apiClient.delete,
      endPoint.deleteDyanamicItem("quotation", action.payload),
    );
    yield put({
      type: types.DELETE_QUOTATION_SUCCESS,
      payload: data,
    });
  } catch (e) {
    const payload = e?.response?.data || e;
    yield put({
      type: types.DELETE_QUOTATION_ERROR,
      payload,
    });
  }
}

export function* deleteQuotationWatcherSaga() {
  yield takeLatest(types.DELETE_QUOTATION_START, deleteQuotationHandlerSaga);
}

//single item

function* getSingleQuotationHandlerSaga(action) {
  const apiClient = apiClientFactory();
  try {
    const { data } = yield call(
      apiClient.get,
      endPoint.dynamicList({ path: `quotation/${action.payload}` }),
    );
    yield put({
      type: types.SINGLE_QUOTATION_SUCCESS,
      payload: data.response,
    });
  } catch (e) {
    const payload = e?.response?.data || e;
    yield put({
      type: types.SINGLE_QUOTATION_ERROR,
      payload,
    });
  }
}

export function* getSingleQuotationWatcherSaga() {
  yield takeLatest(types.SINGLE_QUOTATION_START, getSingleQuotationHandlerSaga);
}


// UPDATE QUOTATION
function* updateQuotationHandlerSaga(action) {
  const apiClient = apiClientFactory();

  try {
    const { path, dataId, body } = action.payload;

    const { data } = yield call(
      apiClient.put,
      path, // 👉 NO /id here
      {
        _id: dataId, // 👉 Send ID in payload
        ...body,
      },
    );

    yield put({
      type: types.UPDATE_QUOTATION_SUCCESS,
      payload: data,
    });
  } catch (e) {
    yield put({
      type: types.UPDATE_QUOTATION_ERROR,
      payload: e?.response?.data || e,
    });
  }
}


export function* updateQuotationWatcherSaga() {
  yield takeLatest(
    types.UPDATE_QUOTATION_START,
    updateQuotationHandlerSaga
  );
}


